const SocialIcon = ({ href, title, color, children, className = '' }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      className={`${className} transition-transform duration-200 ease-in-out hover:scale-110`}
      style={{ color }}
    >
      {children}
    </a>
  );
};

export default SocialIcon;
